import { applyGuestLoginDeepLink, useGuestLoginDeepLinkPending } from '~/composables/useGuestLoginDeepLink'
import { parseGuestLoginQuery } from '~/utils/guestLoginDeepLink'

/**
 * Banner URLs (`?guest=login` / `?guest=register`) open the guest modal after
 * hydration so SSR HTML stays closed (no mismatch). Captures the intent
 * synchronously so One Tap can skip before this plugin's onNuxtReady runs.
 */
export default defineNuxtPlugin(() => {
  const route = useRoute()
  const pending = useGuestLoginDeepLinkPending()
  const fromQuery = parseGuestLoginQuery(route.query.guest)
  if (fromQuery) {
    pending.value = fromQuery
  }

  onNuxtReady(() => {
    void applyGuestLoginDeepLink()
  })

  // SPA navigations (in-app banner / later ?guest=login). Browser back that
  // restores the banner URL is ignored by applyGuestLoginDeepLink (same URL
  // already opened once) and only strips `guest` again.
  watch(() => route.query.guest, (guest) => {
    if (!parseGuestLoginQuery(guest)) {
      return
    }
    void applyGuestLoginDeepLink()
  })
})
